import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const usePeriodeStore = defineStore("periode", () => {
  const mode       = ref<"annee" | "plage" | "tout">("annee");
  const annee      = ref(new Date().getFullYear());
  const date_debut = ref("");
  const date_fin   = ref("");

  const params = computed<Record<string, any>>(() => {
    if (mode.value === "tout")  return { mode: "tout" };
    if (mode.value === "plage" && date_debut.value && date_fin.value) {
      return { mode: "plage", date_debut: date_debut.value, date_fin: date_fin.value };
    }
    return { annee: annee.value };
  });

  function setAnnee(a: number) {
    mode.value  = "annee";
    annee.value = a;
  }

  function setPlage(debut: string, fin: string) {
    mode.value       = "plage";
    date_debut.value = debut;
    date_fin.value   = fin;
  }

  function setTout() {
    mode.value = "tout";
  }

  return { mode, annee, date_debut, date_fin, params, setAnnee, setPlage, setTout };
});
